module.exports = __webpack_public_path__ + "img/base_activites_guide.05eb63b2.svg";